export default __webpack_public_path__ + "static/media/Path3431.0079c9f1.svg";